import { useEffect } from 'react';

import { openSplashNotification } from 'src/layouts/SplashNotificationPopup/useOpenSplashNotification';

import { useAppSettingsQuery } from '@queries/AppQueries';
import { useCurrentEntertainerQuery } from '@queries/EntertainerQueries';
import { useCurrentUser } from '@queries/UserQueries';

import { useCapacitorUpdateAvailable } from '@hooks/useCapacitorUpdateAvailable';

import { createScreenComponent } from '@utilities/createScreenComponent';

import { EntertainerDashboardScreen } from './EntertainerDashboardScreen';
import { NonEntertainerDashboardScreen } from './NonEntertainerDashboardScreen';

export const DashboardScreen = createScreenComponent<{ tab?: any }>((props) => {
  const { currentUser } = useCurrentUser();
  const { entertainer, entertainerIsReady } = useCurrentEntertainerQuery();
  const { appSettingsAreReady, appSettings } = useAppSettingsQuery();
  const { isCapacitorUpdateAvailable, updateApp } = useCapacitorUpdateAvailable();

  useEffect(() => {
    if (isCapacitorUpdateAvailable) {
      openSplashNotification({
        _id: 'ota-app-update',
        title: 'App Update Available',
        content: 'An update is available for the app. Would you like to update now?',
        displayPath: '*',
        button: {
          text: 'Update',
          to: '',
          action: updateApp,
        },
      });
    }
  }, [isCapacitorUpdateAvailable]);

  if (currentUser?.entertainerId || entertainer?._id) {
    return <EntertainerDashboardScreen {...props} />;
  }

  return <NonEntertainerDashboardScreen {...props} />;
});
